module.exports = __webpack_public_path__ + "assets/9cfc8067d402be6777b0aeb638cdbd51.mp3";